import * as React from 'react';
import ReferenceRateEditor from '../coupons/ReferenceRateEditor';
import RangeValueSwitch from './RangeValueSwitch';
import VariationEditor from './VariationEditor';
import RangeEditor from './RangeEditor';
import ValueBaseEditor from './ValueBaseEditor';
import FloatingGuidance from '../../../../../../models/data/FloatingGuidance';
const FloatingGuidanceEditor = ({ value, onChange }) => {
    const [rangeValue, setRangeValue] = React.useState(value?.range !== undefined ? 'range' : 'value');
    const onChangeRange = React.useCallback((event) => {
        const updated = value !== undefined ? value.updateRange(event.target.value) : new FloatingGuidance({ range: event.target.value });
        onChange({ target: { value: updated } });
    }, [onChange, value]);
    const onChangeValue = React.useCallback((event) => {
        const updated = value !== undefined ? value.updateValue(event.target.value) : new FloatingGuidance({ value: event.target.value });
        onChange({ target: { value: updated } });
    }, [onChange, value]);
    const onChangeReference = React.useCallback((event) => {
        const updated = value !== undefined ? value.updateReferenceRate(event.target.value) : new FloatingGuidance({ referenceRate: event.target.value });
        onChange({ target: { value: updated } });
    }, [value, onChange]);
    const onChangeVariation = React.useCallback((event) => {
        const updated = value !== undefined ? value.updateVariation(event.target.value) : new FloatingGuidance({ variation: event.target.value });
        onChange({ target: { value: updated } });
    }, [onChange, value]);
    const content = React.useMemo(() => {
        switch (rangeValue) {
            case 'range':
                return React.createElement(RangeEditor, { value: value?.range, onChange: onChangeRange });
            case 'value':
                return React.createElement(ValueBaseEditor, { value: value?.value, onChange: onChangeValue });
            default:
                return undefined;
        }
    }, [onChangeRange, onChangeValue, rangeValue, value?.range, value?.value]);
    return (React.createElement(React.Fragment, null,
        React.createElement(RangeValueSwitch, { name: 'float', rangeValue: rangeValue, setRangeValue: setRangeValue }),
        React.createElement("div", { style: { display: 'flex' } },
            React.createElement(ReferenceRateEditor, { disabled: false, value: value?.referenceRate, onChange: onChangeReference, style: { alignSelf: 'end', marginRight: '0.25rem' } }),
            content,
            React.createElement(VariationEditor, { value: value?.variation, onChange: onChangeVariation }))));
};
export default FloatingGuidanceEditor;
